[
  {
    "name": "Jesús Montoya",
    "birthdate": "02/03/1992",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/146495427.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 179,
    "draftJersey": 2,
    "macros": {
      "reflexes": 87,
      "diving": 93,
      "duels": 84,
      "passing": 86,
      "handling": 93,
      "anticipation": 87,
      "average": 84
    },
    "matchYtVideoId": "jG94uNlKyoo",
    "profileYtVideoId": "9bjT9HuJ-Cw"
  },
  {
    "draftJersey": 4,
    "draftJerseyPrefix":  "MED",
    "role": "PT",
    "name": "Sergio Alfaro",
    "foot": "right",
    "height": 184,
    "birthdate": "31/03/2000",
    "country": "CRC",
    "macros": {
      "anticipation": 70,
      "duels": 91,
      "diving": 91,
      "handling": 81,
      "reflexes": 91,
      "passing": 82,
      "average": 81
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/156417628.png",
    "profileYtVideoId": "my5M55zz7Sw",
    "matchYtVideoId": "W_28qAbqZCA"
  },
  {
    "name": "Luis Yáñez",
    "birthdate": "01/09/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/984167371.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 178,
    "draftJersey": 5,
    "macros": {
      "reflexes": 96,
      "diving": 92,
      "duels": 87,
      "passing": 66,
      "handling": 87,
      "anticipation": 82,
      "average": 83
    },
    "matchYtVideoId": "z_AfMOID0GU",
    "profileYtVideoId": "0XQqYMmp5qk"
  },
  {
    "name": "Omar Ramírez",
    "birthdate": "16/06/1993",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/30431866.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "left",
    "height": 170,
    "draftJersey": 6,
    "macros": {
      "reflexes": 77,
      "diving": 69,
      "duels": 92,
      "passing": 62,
      "handling": 87,
      "anticipation": 74,
      "average": 77
    },
    "matchYtVideoId": "-YqVg8StXb0",
    "profileYtVideoId": "aIfPhsEuR7k"
  },
  {
    "name": "Dalton Weeks",
    "birthdate": "07/11/1994",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/577482115.png",
    "country": "United States",
    "role": "PT",
    "foot": "right",
    "height": 195,
    "draftJersey": 7,
    "macros": {
      "reflexes": 83,
      "diving": 93,
      "duels": 88,
      "passing": 68,
      "handling": 84,
      "anticipation": 79,
      "average": 80
    },
    "matchYtVideoId": "micMkoQodlQ",
    "profileYtVideoId": "kRkhD8oJ2nU"
  },
  {
    "name": "Ángel Espinoza",
    "birthdate": "25/04/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/50426949.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 180,
    "draftJersey": 9,
    "macros": {
      "reflexes": 88,
      "diving": 97,
      "duels": 75,
      "passing": 68,
      "handling": 88,
      "anticipation": 68,
      "average": 78
    },
    "matchYtVideoId": "jG94uNlKyoo",
    "profileYtVideoId": "5nNF2e1_1SE"
  },
  {
    "name": "Alejandro Peláez",
    "birthdate": "04/02/1994",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/62125348.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 188,
    "draftJersey": 59,
    "macros": {
      "reflexes": 75,
      "diving": 94,
      "duels": 93,
      "passing": 80,
      "handling": 89,
      "anticipation": 83,
      "average": 82
    },
    "matchYtVideoId": "pWP_V2U89rY",
    "profileYtVideoId": "ldvadDvKrVI"
  },
  {
    "name": "Alejandro Carrillo",
    "birthdate": "05/11/2004",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/768656096.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 177,
    "draftJersey": 60,
    "macros": {
      "reflexes": 92,
      "diving": 92,
      "duels": 74,
      "passing": 77,
      "handling": 96,
      "anticipation": 83,
      "average": 82
    },
    "matchYtVideoId": "V9gvCo9fK-k",
    "profileYtVideoId": "6ssxWe4VEus"
  },
  {
    "name": "Juan Ruiz",
    "birthdate": "09/01/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/537750962.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 183,
    "draftJersey": 61,
    "macros": {
      "reflexes": 78,
      "diving": 96,
      "duels": 74,
      "passing": 73,
      "handling": 96,
      "anticipation": 80,
      "average": 79
    },
    "matchYtVideoId": "V9gvCo9fK-k",
    "profileYtVideoId": "offzNQOWtzA"
  },
  {
    "name": "Eduardo Evangelista",
    "birthdate": "06/08/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/788790824.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 173,
    "draftJersey": 62,
    "macros": {
      "reflexes": 83,
      "diving": 93,
      "duels": 84,
      "passing": 82,
      "handling": 88,
      "anticipation": 83,
      "average": 81
    },
    "matchYtVideoId": "sZPK0-NQQtI",
    "profileYtVideoId": "n3CC9hPw5fQ"
  },
  {
    "name": "José Méndez",
    "birthdate": "11/07/1990",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/718657401.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 175,
    "draftJersey": 63,
    "macros": {
      "reflexes": 74,
      "diving": 96,
      "duels": 74,
      "passing": 67,
      "handling": 92,
      "anticipation": 77,
      "average": 76
    },
    "matchYtVideoId": "PCm93Pg61jY",
    "profileYtVideoId": "OXmndjjoUcI"
  },
  {
    "name": "Walter Gómez",
    "birthdate": "20/07/1995",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/872562978.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 179,
    "draftJersey": 66,
    "macros": {
      "reflexes": 79,
      "diving": 93,
      "duels": 88,
      "passing": 69,
      "handling": 88,
      "anticipation": 79,
      "average": 80
    },
    "matchYtVideoId": "pWP_V2U89rY",
    "profileYtVideoId": "DzPUH2uNveg"
  },
  {
    "name": "Leonardo Tapia",
    "birthdate": "23/02/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/953653742.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "left",
    "height": 183,
    "draftJersey": 67,
    "macros": {
      "reflexes": 79,
      "diving": 88,
      "duels": 88,
      "passing": 77,
      "handling": 97,
      "anticipation": 82,
      "average": 83
    },
    "matchYtVideoId": "sZPK0-NQQtI",
    "profileYtVideoId": "0j8WuMAxebY"
  },
  {
    "name": "Erik Fraire",
    "birthdate": "24/09/1993",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/758360033.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 190,
    "draftJersey": 120,
    "macros": {
      "reflexes": 79,
      "diving": 97,
      "duels": 84,
      "passing": 77,
      "handling": 98,
      "anticipation": 83,
      "average": 83
    },
    "matchYtVideoId": "sZPK0-NQQtI",
    "profileYtVideoId": "iZX11BgAp3E"
  },
  {
    "name": "Diego Reynoso",
    "birthdate": "05/01/1989",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/299497495.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 175,
    "draftJersey": 121,
    "macros": {
      "reflexes": 87,
      "diving": 96,
      "duels": 92,
      "passing": 68,
      "handling": 92,
      "anticipation": 83,
      "average": 84
    },
    "matchYtVideoId": "SfSCnEEBcnM",
    "profileYtVideoId": "QLl3WYk_XIQ"
  },
  {
    "name": "Sebastián Leyva",
    "birthdate": "24/01/2006",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/300832575.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "left",
    "height": 172,
    "draftJersey": 122,
    "macros": {
      "reflexes": 87,
      "diving": 88,
      "duels": 79,
      "passing": 71,
      "handling": 97,
      "anticipation": 80,
      "average": 81
    },
    "matchYtVideoId": "CViP_eshlG8",
    "profileYtVideoId": "r7By8vVgLLc"
  },
  {
    "name": "Ángel Rascón",
    "birthdate": "05/04/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/340746263.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "left",
    "height": 180,
    "draftJersey": 125,
    "macros": {
      "reflexes": 92,
      "diving": 88,
      "duels": 79,
      "passing": 76,
      "handling": 88,
      "anticipation": 81,
      "average": 81
    },
    "matchYtVideoId": "sZPK0-NQQtI",
    "profileYtVideoId": "8hACQYOqRXo"
  },
  {
    "name": "Marco Millán",
    "birthdate": "01/09/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/565713418.png",
    "country": "Mexico",
    "role": "PT",
    "foot": "right",
    "height": 183,
    "draftJersey": 200,
    "macros": {
      "reflexes": 84,
      "diving": 97,
      "duels": 79,
      "passing": 79,
      "handling": 88,
      "anticipation": 82,
      "average": 80
    },
    "matchYtVideoId": "micMkoQodlQ",
    "profileYtVideoId": "M3LTVoyxFPI"
  }
]
